<section class="row d-none d-md-flex">
  <div class="col-12 col-md-6">
    @for (value of homePageResouces | async; track value; let even = $even) {
      @if (even) {
        <ng-container *ngTemplateOutlet="itemTemplate; context: {item: value}"> </ng-container>
      }
    }
  </div>
  <div class="col-12 col-md-6">
    @for (value of homePageResouces | async; track value; let odd = $odd) {
      @if (odd) {
        <ng-container *ngTemplateOutlet="itemTemplate; context: {item: value}"> </ng-container>
      }
    }
  </div>
</section>

<section class="d-md-none">
  @for (value of homePageResouces | async; track value) {
    <ng-container *ngTemplateOutlet="itemTemplate; context: {item: value}"> </ng-container>
  }
</section>

<ng-template #itemTemplate let-value="item">
  <mat-card appearance="filled" class="mb-4">
    <mat-card-header>
      <div mat-card-avatar (click)="openHomePageItem(value)">
        <mat-icon>{{ value.icon }}</mat-icon>
      </div>
      <mat-card-title>
        <button matButton (click)="openHomePageItem(value)">
          {{ value.displayname }}
        </button>
      </mat-card-title>
    </mat-card-header>
    @if (value.description || value.items?.length > 0) {
      <mat-card-content>
        <mat-card appearance="raised" class="inner-card">
          <mat-card-content>{{ value.description }}</mat-card-content>
          <mat-card-actions>
            @for (item of value.items; track item) {
              <button
                matButton="outlined"
                class="action-button"
                (click)="openHomePageItem(item); $event.preventDefault()"
              >
                {{ item.displayname }}
              </button>
            }
          </mat-card-actions>
        </mat-card>
      </mat-card-content>
    }
  </mat-card>
</ng-template>
